import React, { useEffect, useState } from 'react';
import { TextField, Button, Grid, Typography, Paper } from '@mui/material';
import { apiLogin } from '../../services/accounts/Login';
import './loginComponent.css';

const LoginComponent = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [validationMessage, setValidationMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        document.body.classList.add('login-route');

        return () => {
            document.body.classList.remove('login-route');
        };
    }, []);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Here you can add your login logic, like sending a request to the server

        if (!isLoading) {
            setIsLoading(true);
            let result = await apiLogin.post({
                login: email,
                password: password,
            });

            if (result.error) {
                setIsLoading(false);
                setValidationMessage(result.error);
            } else if (result.token) {
                localStorage.setItem('token', result.token);
                localStorage.setItem('fullName', result.fullName);
                localStorage.setItem('role', result.roleId);
                localStorage.setItem('email', result.name);
                localStorage.setItem('avatar', result.avatar);
                window.location.href = '/absenceList';
            }
        }

        // Reset the form after submission
        setEmail('');
        setPassword('');
    };

    return (
        <div className="home-container login-page">
            <br />
            <br />
            <div className="home-hero">
                <Grid
                    container
                    justifyContent="center"
                    className="padding-body-2"
                >
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={0}
                            variant="outlined"
                            square={false}
                            className="login-paper"
                        >
                            <form onSubmit={handleSubmit}>
                                <div className="login-figma-hero">
                                    <div className="login-welcome">
                                        Witaj w aplikacji
                                    </div>
                                    <div className="login-brand">
                                        Agema<span>HOME</span>
                                    </div>
                                    <div className="login-avatar">
                                        <div className="login-avatar-head"></div>
                                        <div className="login-avatar-body"></div>
                                    </div>
                                </div>

                                <Typography
                                    variant="h5"
                                    gutterBottom
                                    className="login-title"
                                >
                                    Zaloguj się
                                </Typography>

                                <Grid item xs={12}>
                                    {validationMessage && (
                                        <div className="validation-error">
                                            Login lub haslo jest niepoprawne
                                        </div>
                                    )}
                                </Grid>

                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={email}
                                    onChange={handleEmailChange}
                                    required
                                    autoComplete="off"
                                />
                                <TextField
                                    type="password"
                                    label="Hasło"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={password}
                                    onChange={handlePasswordChange}
                                    required
                                    autoComplete="off"
                                />

                                <div className="login-actions">
                                    <div className="login-forgot-wrap">
                                        <a
                                            href="/forgot"
                                            className="forgot-password"
                                        >
                                            Zapomniales hasla?
                                        </a>
                                    </div>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        fullWidth
                                        size="large"
                                        className="buttonFilled"
                                    >
                                        {isLoading && (
                                            <span className="loader"></span>
                                        )}
                                        {!isLoading && <span>Zaloguj</span>}
                                    </Button>
                                </div>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default LoginComponent;
